import { useState, useCallback } from "react";
import { IProjectConfig } from "../../types";
import { DEFAULT_PROJECT_CONFIG } from "../../consts";
import { setStateURL, getTypedVal } from "../../utils/urls";

/**
 * Hook to manage project configuration and portfolio state.
 * Consolidates: useProjectConfig, usePortfolio
 */
export function useProject() {
  // Portfolio ID (initialized from URL)
  const [portfolioId, setPortfolioId] = useState<string>(() => getTypedVal("portfolio_id") ?? "");

  // Project config
  const [projectConfig, setProjectConfig] = useState<IProjectConfig>({ ...DEFAULT_PROJECT_CONFIG });

  // Update a single project field with optional URL sync
  const updateProject = useCallback((key: string, value: string) => {
    if (getTypedVal("htr_url_statefulurl")) {
      setStateURL(key, value);
    }
    setProjectConfig((prev) => ({ ...prev, [key]: value }));
  }, []);

  return {
    // Portfolio
    portfolioId,
    setPortfolioId,

    // Project config
    projectConfig,
    setProjectConfig,
    updateProject,
  };
}
